import styled from 'styled-components'

export const Wrap = styled.div`
  width: 2.5rem;
  height: 2.5rem;
  // so the icon doesn't shrink and disappear
  min-width: 2.5rem;
  min-height: 2.5rem;
  overflow: hidden;
  margin-right: 0.625rem;
  display: flex;
  justify-content: center;
  img {
    width: 100%;
  }
`
